import { useEffect } from 'react';
import { useLocaleSwitchApp } from '@base/hooks/i18n';

import { injectedComponent } from '@base/core';
import { isVkOAuthCallbackWithParams } from '@base/utils/utils';

export default injectedComponent(
  {
    name: 'LoggedLandingGuard',
    services: ['access', 'api'],
  },
  function LoggedLandingGuard({ children, services: { access, api } }) {
    const switchApp = useLocaleSwitchApp();
    const searchParams = new URLSearchParams(window.location.search);
    const action = searchParams.get('action');
    const checkResult = searchParams.get('checkResult');
    const error = searchParams.get('error');
    const reason = searchParams.get('reason');
    const accessToken = searchParams.get('accessToken');

    const hasImportantParams = 
      action === 'change_password' || 
      action === 'signup' ||
      action === 'login' ||
      checkResult;

    const pathname =
      typeof window !== 'undefined' && window.location.pathname ? window.location.pathname : '';
    const isVkOAuthInbound = isVkOAuthCallbackWithParams(pathname, searchParams);
    
    useEffect(() => {
      if (accessToken && action === 'login' && checkResult === '1' && !access.hasAnyAccess() && access.detected ) {
        const handleAccessTokenLogin = async () => {
          try {
            if (access.hasAnyAccess()) {
              return;
            }
            
            const data = await api.isLoggedIn({ options: { authToken: accessToken } });
            if (data && data.isLogged) {
              access.login(accessToken, {
                memberId: data.memberId,
                isLogged: true,
                fullMemberAccess: data.fullMemberAccess || false,
                viewCabinetMemberAccess: data.viewCabinetMemberAccess || false,
              });
            }
          } catch (e) {
            console.error('Error processing accessToken:', e);
          }
        };
        
        handleAccessTokenLogin();
      }
    }, [accessToken, checkResult, access.isLogged, access.detected, access, api]);
    
    if (!access.hasAnyAccess()) {
      return children;
    }
    if (isVkOAuthInbound) {
      return children;
    }
    if (hasImportantParams) {
      const urlParams = {};
      for (const [key, value] of searchParams.entries()) {
        if (key !== 'accessToken') {
          urlParams[key] = value;
        }
      }
      switchApp('my', urlParams);
    } else {
      switchApp('my');
    }

    return null;
  }
);
